import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

// CrowdStrike domains for different regions
const CROWDSTRIKE_DOMAINS = [
  { value: "us-1", label: "US-1" },
  { value: "us-2", label: "US-2" },
  { value: "eu-1", label: "EU-1" },
  { value: "usgov1", label: "GOV" },
];

export default function CrowdStrikeConnectForm({
  onSubmit,
  guideMode = false,
}) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const formInitialValues = {
    clientId: "",
    secret: "",
    domain: "us-1",
  };
  const formCheckoutSchema = yup.object().shape({
    clientId: yup.string().required("required"),
    secret: yup.string().required("required"),
    domain: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="clientId"
                label="CrowdStrike Client ID"
                value={values.clientId}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.clientId && !!errors.clientId}
                helperText={touched.clientId && errors.clientId}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                type={showSecret ? "text" : "password"}
                name="secret"
                autoComplete="off"
                label="Secret"
                value={values.secret}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.secret && !!errors.secret}
                helperText={touched.secret && errors.secret}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <FormControl variant="filled" fullWidth>
                <InputLabel id="domain-select-label">
                  CrowdStrike Environment
                </InputLabel>
                <Select
                  labelId="domain-select-label"
                  id="domain-select"
                  name="domain"
                  value={values.domain}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!touched.domain && !!errors.domain}
                  disabled={guideMode}
                >
                  {CROWDSTRIKE_DOMAINS.map((domain) => (
                    <MenuItem key={domain.value} value={domain.value}>
                      {domain.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
